import './assets/css/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue/client'

import installTheme from './theme';
import installComponents from './components';
import installDirectives from './directives';
import translations from './translations';
import router from './router';

// plugins
import action from './plugins/actions';
import resources from './plugins/resources';
import api from './plugins/api';
import logger from './plugins/logger';
import VWave from 'v-wave';
import sentry from './plugins/sentry';

// view init
import App from './App.vue'
const app = createApp(App);
const head = createHead();

installTheme(app);
installComponents(app);
installDirectives(app);

app.use(sentry, { router });
app.use(resources);
app.use(translations);
app.use(action);
app.use(createPinia());
app.use(router);
app.use(head);
app.use(api);
app.use(logger);
app.use(VWave);

app.mount('#app')
